import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=51027c9e&"
import script from "./Notices.vue?vue&type=script&lang=ts&"
export * from "./Notices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports